module.exports = __webpack_public_path__ + "static/img/00080B_2_3_R_20190806_fit.27b5754.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/00080B_2_3_R_20190806_fit.png
// module id = UCXd
// module chunks = 0